<template>
  <header class="header-area">
    <!--
    <top-bar />
    -->
    <div class="header-centerbar">
      <div class="container">
        <!-- PC端布局：logo和登录/注册按钮在同一行 -->
        <div class="row align-items-center justify-content-between d-none d-lg-flex">
          <div class="col-lg-8 col-sm-3 col-3">
            <div class="logo">
              <router-link to="/">
                <div class="flex">
                  <!--
                  <img :src="require(`@/assets/images/` + image)" alt="树人科技" />
                  -->
                  <img :src="require(`@/assets/images/logo_text.png`)" class="logo_text" alt="树人科技" />
                </div>
              </router-link>
            </div>
          </div>

          <!-- 登录/注册按钮（居右） -->
          <div class="col-lg-4 col-sm-9 col-9 d-flex justify-content-end">
            <template v-if="userProfile?.id">   
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <div class="avatar-container">
                    <div class="avatar-container">
                      <template v-if="initPwd === 'false'">
                        <el-badge :value="1" class="item">
                          <img
                            :src="userProfile.avatarurl || require('@/assets/images/default_avatar.png')"
                            alt="用户头像"
                            class="user-avatar"
                          />
                        </el-badge>
                      </template>
                      
                      <template v-else>
                        <img
                          :src="userProfile.avatarurl || require('@/assets/images/default_avatar.png')"
                          alt="用户头像"
                          class="user-avatar"
                        />
                      </template>
                    </div>
                  </div>
                  {{ userProfile.realname || userProfile.fullname }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-user" command="profile">个人资料</el-dropdown-item>
                  <el-dropdown-item 
                    icon="el-icon-s-flag" 
                    command="manuscripts"
                  >
                    参与项目
                  </el-dropdown-item>
                  <el-dropdown-item 
                    icon="el-icon-s-order" 
                    command="order"
                  >
                    支付订单
                  </el-dropdown-item>

                  <el-dropdown-item 
                    icon="el-icon-key" 
                    command="setPassword"
                    style="color: red;"
                    v-if="initPwd === 'false'"
                  >
                    初始化密码
                  </el-dropdown-item>

                  <el-dropdown-item 
                    icon="el-icon-key" 
                    command="chgPassword"
                    v-if="initPwd === 'true'"
                  >
                    修改密码 
                  </el-dropdown-item>


                  <el-dropdown-item icon="el-icon-switch-button" command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            
            <div class="header-buttons" v-else>
              <el-button 
                type="primary"
                @click="openLoginDialog"
              >
                登录 / 注册
              </el-button>
            </div>
          </div>
        </div>
        
        <!-- 移动端布局：logo单独一行 -->
        <div class="row d-lg-none">
          <div class="col-12 text-center mb-3">
            <div class="logo">
              <router-link to="/">
                <div class="flex justify-content-center">
                  <!--
                  <img :src="require(`@/assets/images/` + image)" alt="树人科技" />
                  -->
                  <img :src="require(`@/assets/images/logo_text.png`)" class="logo_text" alt="树人科技" />
                </div>
              </router-link>
            </div>
          </div>
          
          <!-- 登录/注册按钮和菜单icon在同一行 -->
          <div class="col-12 d-flex justify-content-between align-items-center">
            <!-- 移动端菜单按钮 -->
            <svg
              class="menu-drawer"
              style="cursor: pointer"
              @click.prevent="hideSidebar"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              fill="currentColor"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M3 4h18v2H3V4zm6 7h12v2H9v-2zm-6 7h18v2H3v-2z"></path>
            </svg>
            
            <div class="header-buttons">
              <el-button 
                type="primary"
              >
                登录 / 注册
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-menubar d-none d-lg-block">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-12 col-sm-3 col-3">
            <svg
              class="menu-drawer"
              style="cursor: pointer"
              @click.prevent="hideSidebar"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              fill="currentColor"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M3 4h18v2H3V4zm6 7h12v2H9v-2zm-6 7h18v2H3v-2z"></path>
            </svg>
            <nav-items :darkClass="darkClass" />
          </div>
        </div>
      </div>
    </div>

    

    <LoginRegisterDialog 
      :visible.sync="showLoginDialog" 
      :defaultTab="'phoneRegister'"
      @registerSuccess="handleLoginSuccess"
    />

  </header>
</template>

<script>
// import TopBar from "./TopBar.vue";
import NavItems from "../Common/NavItems.vue";
import LoginRegisterDialog from "../../Common/LoginRegisterDialog.vue";
import { getProfile } from "@/api/user";
import profileService from '@/utils/profileService';
import { eventBus } from '@/utils/eventBus.js';

export default {
  components: { 
    // TopBar, 
    NavItems,
    LoginRegisterDialog
  },
  props: {
    image: {
      type: String,
      default: "logo.png",
    },
    darkClass: {
      type: Object,
    },
  },
  computed: {
    userProfile() {
      return profileService.getProfile();
    },
    initPwd() {
      return localStorage.getItem('initpwd');
    }
  },
  created() {
    const token = localStorage.getItem('token');
    if (token) {
      this.getUserProfile();
    }
  },
  data: () => ({
    value: null,
    options: ["English", "Bangla", "Hinde"],
    showLoginDialog: false
  }),
  methods: {
    hideSidebar(e) {
      this.$emit("toggleSidebar", e);
    },
    openLoginDialog() {
      this.showLoginDialog = true;
    },
    async getUserProfile() {
      try {
        const response = await getProfile();
        profileService.setProfile(response.data); // 更新共享模块（无需手动赋值 userProfile）
      } catch (error) {
        console.error('获取用户资料失败:', error);
        localStorage.removeItem('token');
      }
    },
    async handleLoginSuccess(token) {
      if (token) {
        localStorage.setItem('token', token);
        await this.getUserProfile();
        eventBus.$emit('userLoggedIn');
      }
    },
    handleCommand(command) {
      switch (command) {
        case 'profile':
          this.handleProfilePage();
          break;
        case 'manuscripts':
          this.handleManuscriptsPage();
          break;
        case 'logout':
          this.handleLogout();
          break;
        case 'order':
          this.handleOrderPage();
          break;
        case 'setPassword':
          this.handleInitPwd();
          break;
        case 'chgPassword':
          this.handleChgPwd();
          break;
        default:
          break;
      }
    },
    handleProfilePage() {
      if (this.$route.name !== 'Profile' || this.$route.query.tab !== '1') {
        this.$router.push({ 
          name: 'Profile', 
          query: { tab: '1' }
        });
      }
    },
    handleInitPwd() {
      if (this.$route.name !== 'Profile' || this.$route.query.tab !== '2') {
        this.$router.push({ 
          name: 'Profile', 
          query: { tab: '2' }
        });
      }
    },
    handleChgPwd() {
      if (this.$route.name !== 'Profile' || this.$route.query.tab !== '3') {
        this.$router.push({ 
          name: 'Profile', 
          query: { tab: '3' }
        });
      }
    },
    handleManuscriptsPage() {
      if (this.$route.name !== 'Profile' || this.$route.query.tab !== '4') {
        this.$router.push({ 
          name: 'Profile', 
          query: { tab: '4' }
        });
      }
    },
    handleOrderPage() {
      if (this.$route.name !== 'Profile' || this.$route.query.tab !== '5') {
        this.$router.push({ 
          name: 'Profile', 
          query: { tab: '5' }
        });
      }
    },
    handleLogout() {
      localStorage.removeItem('token');
      profileService.setProfile(null); 
      eventBus.$emit('userLoggedOut');
      //除了home页外，不需要跳转，
      if (this.$route.name == 'Home') {
        this.$router.push({ name: 'Home' });
      }
    }
  },
};
</script>
<style>
.select-lang {
  border: 1px solid #bababa;
  width: 100px;
  padding: 2px;
  color: #17191d;
  outline: none;
  border-radius: 7px;
}
.flex {
  display: flex;
  align-items: center;
}
.flex img {
  height: 50px;
}
</style>

<style scoped>
/* 按钮样式 */
.login-btn {
  color: #fff;
  padding: 8px 20px;
  border-radius: 4px;
}

.register-btn {
  background: #ff6b58;
  color: #fff;
  padding: 8px 20px;
  border-radius: 4px;
  border: 1px solid #ff6b58;
}

.qrcode-image {
  position: absolute;
  z-index: 1000;
  width: 150px;
  height: auto;
  border: 1px solid #ccc; /* 添加边框 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* 添加阴影 */
}
.login-register .login-btn {
  color: #1482f0 !important;
  font-size: 15px;
  font-weight: 400;
}
.user-avatar{
  width: 25px;
  height: 25px;
  object-fit: cover;
}
/* 添加头像容器定位 */
.avatar-container {
  position: relative;
}
/* 设置下拉链接为flex布局，使头像和姓名同行 */
.el-dropdown-link {
  display: flex;
  align-items: center;
  gap: 8px; /* 调整头像与文字间距 */
}
.el-dropdown-menu__item {
  z-index: 9999 !important;
  pointer-events: auto !important;
}
.el-badge__content.is-fixed{
  top: 1px!important;
}
.el-badge__content{
  line-height: 15px!important;
  height: 15px!important;
  padding: 0 3px!important;
  font-size: 10px!important;
}

/* 调整按钮间距（使用已有工具类 mr-20） */
</style>
